import { registerPlugin, PluginListenerHandle } from "@capacitor/core";

export interface LocationUpdate {
  lat: number;
  lng: number;
  accuracy: number;
}

export interface StashtLocationPlugin {
  startUpdates(): Promise<{ started: boolean }>;
  stopUpdates(): Promise<{ stopped: boolean }>;
  addListener(eventType: "locationUpdate", listener: (value: LocationUpdate) => void): Promise<PluginListenerHandle>;
}

/**
 * Web fallback — startUpdates / stopUpdates are no-ops because the
 * useLocationSync hook drives polling directly via navigator.geolocation
 * on non-native platforms.  The addListener path is likewise unused on web;
 * the hook subscribes to its own interval-based reads instead.
 */
const StashtLocation = registerPlugin<StashtLocationPlugin>("StashtLocation", {
  web: {
    async startUpdates() {
      return { started: true };
    },
    async stopUpdates() {
      return { stopped: true };
    },
    async addListener(_eventType: string, _listener: (value: LocationUpdate) => void): Promise<PluginListenerHandle> {
      // No native events on web; return a no-op handle.
      return { remove: async () => {} };
    },
  },
});

export { StashtLocation };
